import { DateWrap, eventTaglineStyle, maxTextLines, nameStyle } from 'Shared/frontend/Poster';
import { css } from '@emotion/css';
import { Show } from 'solid-js';


export function FallbackNonMusicPoster(P)
{
	const posterStyle = () => css({
		margin: '24px 0.2em 0 0.2em',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'stretch',
		gap: 14,
		textAlign: 'center'
	});

	const eventNameStyle = () => css(nameStyle(), {
		padding: '.5em 0 .5em 0',
		width: '100%',
		...maxTextLines(3),
		fontSize: 24
	});

	const descriptionStyle = () => css(eventTaglineStyle(), {
		padding: '0 0.5em',
		width: '100%',
		...maxTextLines(6),
		fontSize: 15 
	});

	return (
		<DateWrap {...P}>
			<div class={posterStyle()}>
				<Show when={P.name}>
					<div class={eventNameStyle()}>{ P.name }</div>
				</Show>

				<Show when={P.tagline}>
					<div class={descriptionStyle()}>{ P.tagline }</div>
				</Show>
			</div>
		</DateWrap>
	);
}
